"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaPopUp = exports.Error = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var PopUp_1 = __importDefault(require("../PopUp/PopUp"));
var OTPInput_1 = __importDefault(require("../OTPInput/OTPInput"));
var PopUpTitle_1 = __importDefault(require("../PopUp/PopUpTitle/PopUpTitle"));
var PopUpText_1 = __importDefault(require("../PopUp/PopUpText/PopUpText"));
var PopUpLoading_1 = __importDefault(require("../PopUpLoading/PopUpLoading"));
var styledComponentsTheme_1 = __importDefault(require("../../components/styledComponentsTheme/styledComponentsTheme"));
var lodash_1 = require("lodash");
exports.Error = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: absolute;\n  color: #da4725;\n  font-size: 12px;\n  font-family: Montserrat;\n"], ["\n  display: inline-block;\n  position: absolute;\n  color: #da4725;\n  font-size: 12px;\n  font-family: Montserrat;\n"])));
var MfaPopUp = function (_a) {
    var title = _a.title, message = _a.message, mfaPopUpLabel = _a.mfaPopUpLabel, onClearError = _a.onClearError, handleSubmit = _a.handleSubmit, handleCancel = _a.handleCancel, cancelButton = _a.cancelButton, submitButton = _a.submitButton, error = _a.error, loading = _a.loading, extraContent = _a.extraContent, throttleTime = _a.throttleTime;
    var _b = (0, react_1.useState)(''), totpCode = _b[0], setTotpCode = _b[1];
    var darkText = { color: 'black', overflowWrap: 'break-word' };
    var throttledSubmit = (0, react_1.useMemo)(function () { return (0, lodash_1.throttle)(function () { return handleSubmit(totpCode); }, throttleTime !== null && throttleTime !== void 0 ? throttleTime : 400, {
        leading: true,
        trailing: false
    }); }, [totpCode]);
    return (react_1.default.createElement(PopUp_1.default, { type: 'info', onCancel: handleCancel, cancelButton: cancelButton, onSubmit: throttledSubmit, submitButton: submitButton },
        react_1.default.createElement("form", { method: 'post', style: { marginBottom: '85px', position: 'relative' }, onSubmitCapture: function (e) {
                e.preventDefault();
                throttledSubmit();
            }, onSubmit: function (e) {
                e.preventDefault();
                throttledSubmit();
            } },
            react_1.default.createElement(PopUpTitle_1.default, { type: 'info' }, title),
            react_1.default.createElement(PopUpText_1.default, { type: 'info', style: darkText }, message),
            react_1.default.createElement("br", null),
            react_1.default.createElement("b", { style: __assign({ fontFamily: 'Montserrat-Bold' }, darkText) }, mfaPopUpLabel),
            react_1.default.createElement(OTPInput_1.default, { focusIndex: 0, fontSize: 32, inputStyle: {
                    color: styledComponentsTheme_1.default.colors.darkgrey
                }, wrapperStyle: {
                    border: '1px solid black',
                    flex: '1',
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '5px'
                }, onChange: function (e) {
                    setTotpCode(e);
                    onClearError === null || onClearError === void 0 ? void 0 : onClearError();
                } }),
            react_1.default.createElement("input", { type: 'submit', style: {
                    position: 'absolute',
                    left: '-9999px',
                    width: '1px',
                    height: '1px'
                }, tabIndex: -1 }),
            error && react_1.default.createElement(exports.Error, null, error),
            extraContent ? react_1.default.createElement("div", { style: { marginTop: error ? 25 : 0 } }, extraContent) : null),
        react_1.default.createElement(PopUpLoading_1.default, { loading: loading })));
};
exports.MfaPopUp = MfaPopUp;
exports.MfaPopUp.propTypes = {
    loading: prop_types_1.default.bool,
    title: prop_types_1.default.string.isRequired,
    message: prop_types_1.default.string.isRequired,
    onClearError: prop_types_1.default.func.isRequired,
    handleSubmit: prop_types_1.default.func.isRequired,
    handleCancel: prop_types_1.default.func.isRequired,
    error: prop_types_1.default.string
};
exports.MfaPopUp.defaultProps = {
    error: '',
    loading: false
};
exports.default = exports.MfaPopUp;
var templateObject_1;
//# sourceMappingURL=MfaPopUp.js.map